import gql from 'graphql-tag'

export default gql`
  mutation updateLoan($input: UpdateLoanInput!, $loanId: Int = null) {
    updateLoan(input: $input) {
      loan {
        id
        amount
        hardCreditPulled
        product {
          rid
          name
          term
          category
          interimCalculation
          monthsRemainingCutoff
          officerCompAddback
          federalTaxes
          otherTaxes
          livingExpense
          livingPercent
          finalDecision
          manualMin
          manualMax
          prime
          spread(loanId: $loanId)
          rateHash
          tierRates
          productType
        }
      }
    }
  }
`
